import { Button, Col, Form, Grid, Input, InputNumber, notification, Row } from 'antd';
import * as Api from 'api';
import CameraAddMap from 'components/cameraAddMap';
import { CameraPinType } from 'helpers/types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useApi from 'redux/api/api.hook';
import useAuth from 'redux/auth/auth.hook';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const CameraAddPage = () => {
  // const { cameras, filterOptions, setCameras } = useApi();
  const [form] = Form.useForm();
  const { md } = useBreakpoint();
  const history = useHistory();

  const { auth: { profile } } = useAuth();
  const { cameraMapBound } = useApi();
  const [camera, setCamera] = useState<CameraPinType>({
    id: 0,
    name: '',
    IMEI: '',
    latitude: cameraMapBound.center.lat,
    longitude: cameraMapBound.center.lng,
    type: 'Camera',
    fix_location: 0,
  });

  useEffect(() => {
    if (profile) {
      // get cameras and tags

    }
  }, [profile]);

  const onValuesChange = (values, allvalues) => {
    console.log(allvalues);
    const newCamera = { ...camera, ...allvalues };
    setCamera(newCamera);
  };

  const onFinish = (values) => {
    console.log('Success:', values);

    const params = {
      user_id: profile.user_id,
      name: camera.name,
      id: 0,
      latitude: camera.latitude,
      longitude: camera.longitude,
      fix_location: 1,
      api_version: 3,
    };
    Api.CAMERA_CREATE_GENERAL(params).then(((res: any) => {
      const data = JSON.parse(res.text);
      if (data.result == 'ok') {
        const path = '/camera';
        history.push(path);
      } else {
        notification.open({
          message: data.msg,
        });
      }
      // setForecastdata(data.data);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onDragEnd = (evt) => {
    const { latLng } = evt;
    // updateMarkerPositionTxt(latLng);

    const newCamera = {
      ...camera,
      ...{
        latitude: Number(latLng.lat().toFixed(6)),
        longitude: Number(latLng.lng().toFixed(6)),
      },
    };
    setCamera(newCamera);
    form.setFieldsValue(newCamera);
  };
  return (
    <>
      <Row>
        {md && (
          <Col md={12} className={classes.leftMap} style={{ height: '80vh' }}>
            <CameraAddMap camera={camera} onDragEnd={onDragEnd} zoom={cameraMapBound.zoom} />
          </Col>
        )}
        <Col md={12} xs={24}>
          <div className={classes.content} style={{ padding: md ? 24 : 16 }}>
            <Form
              {...layout}
              form={form}
              name="basic"
              initialValues={camera}
              onValuesChange={onValuesChange}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: 'Please input camera name',
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Latitude"
                name="latitude"
                rules={[
                  {
                    required: true,
                    message: 'Latitude',
                  },
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>

              <Form.Item
                label="Longitude"
                name="longitude"
                rules={[
                  {
                    required: true,
                    message: 'Longitude',
                  },
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
              <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
            {!md && (
            <Col xs={24} md={24} style={{ height: '400px' }}>
              <CameraAddMap camera={camera} onDragEnd={onDragEnd} zoom={cameraMapBound.zoom} />
            </Col>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CameraAddPage;
